import Phaser from "phaser";
import { SeasonType } from "../data/enums";
import { REFERENCE_HEIGHT, REFERENCE_WIDTH } from "../game/constants";
import { getLakeByKey } from "../data/lakeData";
import { LeaderboardService } from "../systems/LeaderboardService";
import { ProgressionService } from "../systems/ProgressionService";

interface GameOverData {
    score: number;
    fishCount?: number;
    fishCaught?: number;
    lakeKey?: string;
    season?: SeasonType;
}

export class GameOverScene extends Phaser.Scene {
    constructor() {
        super("GameOverScene");
    }

    create(data: GameOverData): void {
        const toSafeCount = (value: number | undefined): number => {
            const numericValue = Number(value);
            if (!Number.isFinite(numericValue) || numericValue < 0) {
                return 0;
            }

            return Math.floor(numericValue);
        };

        const score = toSafeCount(data.score);
        const fishCaught = data.fishCount !== undefined ? toSafeCount(data.fishCount) : toSafeCount(data.fishCaught);
        const lakeKey = data.lakeKey ?? "lake-mendota";
        const season = data.season ?? SeasonType.Summer;
        const lake = getLakeByKey(lakeKey);
        const lifetime = ProgressionService.addLifetimeScore(score);
        const isLeaderboardScore = LeaderboardService.qualifies(score);

        if (isLeaderboardScore) {
            const initials = window.prompt("New High Score! Enter 3 initials:", "FOX") ?? "FOX";
            LeaderboardService.submitScore(initials, score, lake.name);
        }

        this.add.rectangle(REFERENCE_WIDTH / 2, REFERENCE_HEIGHT / 2, REFERENCE_WIDTH, REFERENCE_HEIGHT, 0x1f2333);

        this.add
            .text(REFERENCE_WIDTH / 2, 220, "Game Over", {
                fontSize: "92px",
                color: "#ffffff",
                fontStyle: "bold",
            })
            .setOrigin(0.5);

        this.add
            .text(REFERENCE_WIDTH / 2, 420, `Score: ${score}\nFish Caught: ${fishCaught}\nLake: ${lake.name}\nLifetime: ${lifetime}`, {
                fontSize: "48px",
                color: "#dbe8ff",
                align: "center",
            })
            .setOrigin(0.5);

        if (isLeaderboardScore) {
            this.add
                .text(REFERENCE_WIDTH / 2, 560, "New High Score!", {
                    fontSize: "52px",
                    color: "#ffe08f",
                    fontStyle: "bold",
                })
                .setOrigin(0.5);
        }

        const playAgain = this.add
            .text(REFERENCE_WIDTH / 2, 690, "Play Again", {
                fontSize: "52px",
                color: "#9ce6ff",
                backgroundColor: "#264f71",
                padding: { left: 24, right: 24, top: 14, bottom: 14 },
            })
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true });

        const menu = this.add
            .text(REFERENCE_WIDTH / 2, 800, "Main Menu", {
                fontSize: "40px",
                color: "#ffffff",
            })
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true });

        playAgain.on("pointerdown", () => this.scene.start("GameplayScene", { lakeKey, season }));
        menu.on("pointerdown", () => this.scene.start("MainMenuScene"));
    }
}
